import { baseState, baseMutations } from '@/store/mixins'
import productPriceSchema from '@/api/restaurant-sale/product-price-schema'

export const state = {
  ...baseState,
  product: [],
  guestLevels: [],
  category_id: undefined,
  pro_group_id: undefined
}
export const getters = {
  getProduct:
    state =>
    ({ chosenProduct, search = '' } = {}) => {
      if (chosenProduct !== undefined) {
        return state.product
          .filter(
            p =>
              !_.includes(
                chosenProduct.map(el => el.product_id),
                p.product_id
              )
          )
          .filter(p =>
            search
              .split(' ')
              .every(s =>
                p.product_name_en.toLowerCase().includes(s.toLowerCase())
              )
          )
          .slice(0, 200)
        // return state.product.filter(p => search.split(' ').every((s) => p.product_name_en.includes(s)));
      }
      return state.product.slice(0, 200)
    },
  getPrice: state => (product_id, uom_id) => {
    if (product_id) {
      return _.ceil(
        state.product
          .filter(p => p.product_id == product_id)
          .map(el => el.sale_code)
          .flat()
          .filter(s => s.uom_id == uom_id)
          .reduce(
            (init, value) => (init = value.product_price.sale_price),
            null
          ),
        2
      )
    }
  },
  getUom: state => product_id => {
    if (product_id) {
      return state.product
        .filter(m => m.product_id == product_id)
        .map(el => el.sale_code)
        .flat()
    }
    return []
  },
  getDefaultUom: state => productId => {
    if (productId) {
      return state.product
        .filter(p => p.product_id == productId)
        .map(el => el.sale_code)
        .flat()
        .filter(s => s.unit_of_measure.is_default == true)
        .reduce((init, value) => (init = value.uom_id), null)
    }

    return 0
  }
}

export const mutations = {
  ...baseMutations,
  SET_PRODUCT (state, product) {
    state.product = product
  },
  SET_GUEST_LEVEL (state, data) {
    state.guestLevels = data
  },
  SET_CATEGORY_ID (state, categoryId) {
    state.category_id = categoryId
  },
  SET_GROUP_ID (state, groupId) {
    state.pro_group_id = groupId
  }
}
export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          category_id: context.state.category_id,
          pro_group_id: context.state.pro_group_id
        }
      },
      attrubutes
    )
    return productPriceSchema.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async getProduct (context, attributes = {}) {
    let response = await productPriceSchema.product({
      params: attributes
    })
    context.commit('SET_PRODUCT', response.data)
  },
  async getGuestLevels (context, attributes = {}) {
    let response = await productPriceSchema.guestLevel({
      params: attributes
    })
    context.commit('SET_GUEST_LEVEL', response.data)
    return response
  },
  getCategory (context) {
    return productPriceSchema.category()
  },
  getGroup (context, params) {
    return productPriceSchema.group(
      params !== undefined ? params.categoryId : context.state.category_id
    )
  },
  store (context, data) {
    return productPriceSchema.store(data)
  },
  destroy (context, id) {
    return productPriceSchema.destroy(id)
  },
  update (context, { id, data }) {
    return productPriceSchema.update(id, data)
  }
}
